import { retry, catchError } from 'rxjs/operators';
import { UtilsService } from '../../../utils/utils';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, using } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class CadastroColaboradorDocumentacaoService {

    routePrefix: string = 'ColaboradorDocumentacao'
    constructor(
        private httpClient: HttpClient,
        private utilsService: UtilsService,
    ) { }

    pesquisar(data = {}): Observable<any> {
        return this.httpClient.post<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarDocumentacaoColaborador`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }
    pesquisarPorUsuarioId(data = {},usuarioId): Observable<any> {
      return this.httpClient.post<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarDocumentacaoColaboradorPorUsuarioId?usuarioId=${usuarioId}`, data)
          .pipe(
              retry(1),
              catchError(this.utilsService.handleError));
  }

    pesquisarPreAdmissao(data: any = {}): Observable<any> {
        return this.httpClient.post<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarDocumentacaoColaboradorPreAdmissao`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    pesquisarPreAdmissaoPorUsuarioId(data: any = {},usuarioId: number): Observable<any> {
      return this.httpClient.post<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarDocumentacaoColaboradorPreAdmissaoPorUsuarioId?usuarioId=${usuarioId}`, data)
          .pipe(
              retry(1),
              catchError(this.utilsService.handleError));
  }

    adicionar(data = {},concluir?: boolean): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/AdicionarDocumentacaoColaborador?concluir=${concluir}`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    editar(data = {},concluir?: boolean): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/EditarDocumentacaoColaborador?concluir=${concluir}`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    remover(data): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/ExcluirDocumentacaoColaborador?id=${data.id}`, {})
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    pesquisarDocumentacao(): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarTudo${this.routePrefix}`, {})
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }
}
